module.exports = __webpack_public_path__ + "static/media/chef-icon.09cc57a3.svg";